import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { TranslationResources } from "Infrastructure/Translations/TranslationResource";

export const useAdvisoryManagementResource = () => {
	return useResource<ResourceDictionary>(
		TranslationResources.AdvisoryManagement,
	);
};

export const AdvisoryManagementResource = Resources.advisoryManagement;
